<template>
  <div>
    <warehouse-table v-show="activeKey===1" ref="list" :addition-picking-modes="additionPickingModes" @add="add" @config="config" @edit="edit"/>
    <warehouse-detail v-show="activeKey===2" ref="detail" :addition-picking-modes="additionPickingModes" :container-types="containerTypes" :order-strategies="orderStrategies" :owners="owners" :wave-strategies="waveStrategies" @back="back"/>
    <warehouse-extra v-show="activeKey===3" ref="extra" :container-types="containerTypes" :conveyors="conveyors" :directions="directions" :distribution-types="distributionTypes" :flow-types="flowTypes" :inspection-types="inspectionTypes" :order-properties="orderProperties" :pack-types="packTypes" :picking-modes="pickingModes" :pickup-modes="pickupModes" :regions="regions" @back="back"/>
  </div>
</template>
<script>
import { findAll } from '@/api/Api'
import WarehouseTable from '@/views/basedata/warehouse/WarehouseTable.vue'
import WarehouseDetail from '@/views/basedata/warehouse/WarehouseDetail.vue'
import WarehouseExtra from '@/views/basedata/warehouse/WarehouseExtra.vue'
import { getDictionaries, getEnums, getOptions } from '@/utils/util'

export default {
  name: 'WarehouseBaseData',
  components: { WarehouseTable, WarehouseDetail, WarehouseExtra },
  data() {
    return {
      activeKey: 1,
      owners: [],
      orderStrategies: [],
      waveStrategies: [],
      containerTypes: [],
      pickupModes: [],
      regions: [],
      orderProperties: [],
      additionPickingModes: [],
      inspectionTypes: [],
      pickingModes: [],
      flowTypes: [],
      packTypes: [],
      distributionTypes: [],
      conveyors: [],
      directions: []
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getDictionaries('ORDER_STRATEGY')
    }).then(result => {
      this.orderStrategies = result
      return getDictionaries('WAVE_STRATEGY')
    }).then(result => {
      this.waveStrategies = result
      return findAll('containerTypeFactory', { available: true })
    }).then(res => {
      if (res.success) {
        this.containerTypes = getOptions(res.result)
      }
      return getDictionaries('PICKUP_MODE')
    }).then(result => {
      this.pickupModes = result
      return getDictionaries('ZONE_REGION')
    }).then(result => {
      this.regions = result
      return getDictionaries('ORDER_PROPERTY')
    }).then(result => {
      this.orderProperties = result
      return getEnums('AdditionPickingMode')
    }).then(result => {
      this.additionPickingModes = result
      return getEnums('InspectionType')
    }).then(result => {
      this.inspectionTypes = result
      return getEnums('PickingMode')
    }).then(result => {
      this.pickingModes = result
      return getEnums('FlowType')
    }).then(result => {
      this.flowTypes = result
      return getEnums('PackType')
    }).then(result => {
      this.packTypes = result
      return getEnums('DistributionType')
    }).then(result => {
      this.distributionTypes = result
      return getDictionaries('CONVEYOR')
    }).then(result => {
      this.conveyors = result
      return getDictionaries('DIRECTION')
    }).then(result => {
      this.directions = result
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.fetch()
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.add()
    },
    edit(id, copy) {
      this.activeKey = 2
      this.$refs.detail.refresh(id, copy)
    },
    config(warehouse) {
      this.activeKey = 3
      this.$refs.extra.refresh(warehouse)
    }
  }
}
</script>